import React from "react";
import CustomModal from "../Common/CustomModal";
import { Box } from "@mui/material";

const TutorialVideoModal = ({ open, handleClose, videoUrl }) => {
  return (
    <CustomModal
      open={open}
      handleClose={handleClose}
      title="Tutorial Video"
      noBtns
      height="55%"
      width="700px"
    >
      <Box sx={{ padding: 2 }}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: 700,
            aspectRatio: "16 / 9",
            margin: "0 auto",
            borderRadius: "16px",
            overflow: "hidden",
            "& iframe": {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
            },
          }}
        >
          <iframe
            src={videoUrl}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Box>
      </Box>
    </CustomModal>
  );
};

export default TutorialVideoModal;
